import React from "react";
import {useIntl} from "react-intl";
import moment from "moment";

export function setLeaveApprovalColumns(approveIconRender, showStaffNo) {
  const intl = useIntl();
  return [
    {
      name: "id",
      label: "ID",
      options: {
        filter: false,
        sort: true,
        display: false,
      }
    },
    {
      name: "staffNo",
      label: intl.formatMessage({id: 'leave_approval.staff_number'}),
      options: {
        filter: true,
        sort: true,
        filterType: "textField",
        display: showStaffNo,
      }
    },
    {
      name: "employeeName",
      label: intl.formatMessage({id: 'leave_approval.employee'}),
      options: {
        filter: true,
        sort: true,
        filterType: "textField",
      }
    },
    {
      name: "position",
      label: intl.formatMessage({id: 'leave_approval.position'}),
      options: {
        filter: true,
        sort: true,
        filterType: "textField",
      }
    },
    {
      name: "location",
      label: intl.formatMessage({id: 'leave_approval.location'}),
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "department",
      label: intl.formatMessage({id: 'leave_approval.department'}),
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "type",
      label: intl.formatMessage({id: 'new_application.leave_type'}),
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "startDate",
      label: intl.formatMessage({id: 'common.from'}),
      options: {
        filter: false,
        sort: true,
      }
    },
    {
      name: "untilDate",
      label: intl.formatMessage({id: 'common.to'}),
      options: {
        filter: false,
        sort: true,
      }
    },
    {
      name: "period",
      label: intl.formatMessage({id: 'new_application.taken'}),
      options: {
        filter: false,
        sort: true,
      }
    },
    {
      name: "dateSubmitted",
      label: intl.formatMessage({id: 'table.date_submitted'}),
      options: {
        filter: false,
        sort: true,
      }
    },
    {
      name: "approve",
      label: intl.formatMessage({id: 'leave_approval.approval'}),
      options: {
        filter: false,
        sort: true,
        empty: true,
        customBodyRender: approveIconRender,
      }
    },
  ];
}
export function setLeaveApprovalOptions(
    selectItem, 
    showSelectBox, 
    customToolbar, 
    handleOpen, 
    customToolbarSelect, 
    checkIsNewCompLeave,
    rowsPerPage,
  ) {
  return {
    filterType: 'checkbox',
    elevation: 1,
    download: false,
    print: false,
    search: false,
    rowsSelected: selectItem,
    selectableRows: showSelectBox,
    customToolbar: customToolbar,
    onRowClick: (rowData, rowMeta) => {
      const isCompLeave = checkIsNewCompLeave(rowData[7]);
      handleOpen(rowData[0], isCompLeave);
    },
    customToolbarSelect: customToolbarSelect,
    textLabels: textLabels(),
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [rowsPerPage]
  };
}

export function setApprovalHistoryColumns(showStaffNo) {
  const intl = useIntl();
  return [
    {
      name: "id",
      label: "ID",
      options: {
        filter: false,
        sort: true,
        display: false,
      }
    },
    {
      name: "staffNo",
      label: intl.formatMessage({id: 'leave_approval.staff_number'}),
      options: {
        filter: true,
        sort: true,
        filterType: "textField",
        display: showStaffNo,
      }
    },
    {
      name: "employeeName",
      label: intl.formatMessage({id: 'leave_approval.employee'}),
      options: {
        filter: true,
        sort: true,
        filterType: "textField",
      }
    },
    {
      name: "position",
      label: intl.formatMessage({id: 'leave_approval.position'}),
      options: {
        filter: true,
        sort: true,
        filterType: "textField",
      }
    },
    {
      name: "location",
      label: intl.formatMessage({id: 'leave_approval.location'}),
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "department",
      label: intl.formatMessage({id: 'leave_approval.department'}),
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "type",
      label: intl.formatMessage({id: 'new_application.leave_type'}),
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "startDate",
      label: intl.formatMessage({id: 'common.from'}),
      options: {
        filter: false,
        sort: true,
      }
    },
    {
      name: "untilDate",
      label: intl.formatMessage({id: 'common.to'}),
      options: {
        filter: false,
        sort: true,
      }
    },
    {
      name: "period",
      label: intl.formatMessage({id: 'new_application.taken'}),
      options: {
        filter: false,
        sort: true,
      }
    },
    {
      name: "dateSubmitted",
      label: intl.formatMessage({id: 'table.date_submitted'}),
      options: {
        filter: false,
        sort: true,
      }
    },
    {
      name: "dateApproved",
      label: intl.formatMessage({id: 'table.date_approved'}),
      options: {
        filter: false,
        sort: true,
      }
    },
    {
      name: "approveStatus",
      label: intl.formatMessage({id: 'table.status'}),
      options: {
        filter: true,
        sort: true,
        filterList: [intl.formatMessage({id: 'status.2'})],
      }
    },
    {
      name: "approvalComment",
      label: intl.formatMessage({id: 'comment'}),
      options: {
        filter: false,
        sort: true,
        display: false,
      }
    },
  ];
}
export function setApprovalHistoryOptions() {
  return {
    elevation: 1,
    download: false,
    print: false,
    search: false,
    selectableRows: 'none',
    downloadOptions: {
      filename: "ApprovalRecord" + getCurrentDate() + ".csv",
      separator: ","
    },
    textLabels: textLabels(),
  };
}

function textLabels() {
  const intl = useIntl();
 return {
   body: {
     noMatch: intl.formatMessage({id: 'table.no_match'}),
     toolTip: intl.formatMessage({id: 'table.sort'}),
     columnHeaderTooltip: column => intl.formatMessage({id: 'table.sort_for'}) + ` ${column.label}`
   },
   pagination: {
     next: intl.formatMessage({id: 'table.next'}),
     previous: intl.formatMessage({id: 'table.previous'}),
     rowsPerPage: intl.formatMessage({id: 'table.rowsPerPage'}),
     displayRows: intl.formatMessage({id: 'table.displayRows'}),
   },
   toolbar: {
     search: intl.formatMessage({id: 'table.search'}),
     downloadCsv: intl.formatMessage({id: 'table.downloadCsv'}),
     print: intl.formatMessage({id: 'table.print'}),
     viewColumns: intl.formatMessage({id: 'table.viewColumns'}),
     filterTable: intl.formatMessage({id: 'table.filterTable'}),
   },
   filter: {
     all: intl.formatMessage({id: 'table.all'}),
     title: intl.formatMessage({id: 'table.filters'}),
     reset: intl.formatMessage({id: 'table.reset'}),
   },
   viewColumns: {
     title: intl.formatMessage({id: 'table.show_columns'}),
     titleAria: intl.formatMessage({id: 'table.show_hide_table_columns'}),
   },
   selectedRows: {
     text: intl.formatMessage({id: 'table.rows_selected'}),
     delete: "Delete",
     deleteAria: "Delete Selected Rows",
   },
 };
}
function getCurrentDate() {
  const newDate = new Date()
  return moment(newDate).format('_YYYY/MM/DD');
}